// extracted by mini-css-extract-plugin
export default {"ignoredIcon":"qjC6dZw6YXu__4gwtujr"};